export default defineNuxtPlugin(function (nuxtApp) {
  var _useNuxt2App = useNuxt2App(),
    $cookies = _useNuxt2App.$cookies;
  var route = useRoute();
  var expires = new Date();
  expires.setDate(expires.getDate() + 7);
  if (route.query.utm_campaign) $cookies.set('utm_campaign', route.query.utm_campaign, {
    path: '/',
    expires: expires
  });
  if (route.query.utm_medium) $cookies.set('utm_medium', route.query.utm_medium, {
    path: '/',
    expires: expires
  });
  if (route.query.utm_source) $cookies.set('utm_source', route.query.utm_source, {
    path: '/',
    expires: expires
  });
  if (route.query.utm_content) $cookies.set('utm_content', route.query.utm_content, {
    path: '/',
    expires: expires
  });
  if (route.query.utm_referrer || document.referrer !== '') $cookies.set('utm_referrer', route.query.utm_referrer || document.referrer, {
    path: '/',
    expires: expires
  });
});